<!-- eslint-disable vue/multi-word-component-names -->
<template>
    <div class="layouts_menu">
        <div class="menu_box" style="width: 202px;" v-if="isUnfold">
            <template v-if="externalOrderPaths.includes(selectedKey)">
                <div v-for="item_1 in externalOrderRouters" :key="item_1.path">
                    <div class="menu_list_row one_menu_item"
                        v-if="item_1.children.length <= 0 && !noMenuPath.includes(item_1.path)">
                        <div :class="selectedKey.includes(item_1.path) ? 'one_menu_content one_menu_content_sel' : 'one_menu_content'"
                            @click="onMenuItem(item_1)">
                            <div class="title" style="font-weight: 500;">
                                <span :class="`iconfont ${menuIcon[item_1.path]}`" v-if="menuIcon[item_1.path]"></span>
                                <span>{{ item_1.meta.title }}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <div v-for="item_1 in menuDataList" :key="item_1.path">
                    <template
                        v-if="item_1.path != '/develop' && !item_1.hiddenMenu || item_1.path == '/develop' && developIds.includes(store.getters.userInfoData.id)">
                        <div class="menu_list_row one_sub_menu"
                            v-if="item_1.children.length > 0 && !noMenuPath.includes(item_1.path)">
                            <div :class="selectedKey.includes(item_1.path) ? 'one_menu_content one_menu_content_sel' : 'one_menu_content'"
                                @click="onSubMenu(item_1)">
                                <div class="title" style="font-weight: 500;">
                                    <span :class="`iconfont ${menuIcon[item_1.path]}`"
                                        v-if="menuIcon[item_1.path]"></span>
                                    <span>{{ item_1.meta.title }}</span>
                                </div>
                                <div class="icon">
                                    <UpOutlined v-if="openKeys.includes(item_1.path)" />
                                    <DownOutlined v-else />
                                </div>
                            </div>
                            <div
                                :class="openKeys.includes(item_1.path) ? 'two_menu_list_open_box' : 'two_menu_list_off_box'">
                                <div v-for="item_2 in item_1.children" :key="item_2.path">
                                    <template v-if="!item_2.hiddenMenu">
                                        <div class="menu_list_row two_sub_menu"
                                            v-if="item_2?.children?.length > 0 && !noMenuPath.includes(item_2.path)">
                                            <div :class="selectedKey.includes(item_2.path) ? 'one_menu_content one_menu_content_sel' : 'one_menu_content'"
                                                @click="onSubMenu(item_2, item_1)">
                                                <div class="title">
                                                    <span>{{ item_2.meta.title }}</span>
                                                </div>
                                                <div class="icon">
                                                    <UpOutlined v-if="openKeys.includes(item_2.path)" />
                                                    <DownOutlined v-else />
                                                </div>
                                            </div>
                                            <div
                                                :class="openKeys.includes(item_2.path) ? 'three_menu_list_open_box' : 'three_menu_list_off_box'">
                                                <div v-for="item_3 in item_2.children" :key="item_3.path">
                                                    <template v-if="!item_3.hiddenMenu">
                                                        <div class="menu_list_row three_menu_item">
                                                            <div :class="selectedKey.includes(item_3.path) ? 'one_menu_content one_menu_content_sel' : 'one_menu_content'"
                                                                @click="onMenuItem(item_3, item_2, item_1)">
                                                                <div class="title">
                                                                    <span>{{ item_3.meta.title }}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </template>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="menu_list_row two_menu_item"
                                            v-if="item_2?.children?.length <= 0 && !noMenuPath.includes(item_2.path)">
                                            <div :class="selectedKey.includes(item_2.path) ? 'one_menu_content one_menu_content_sel' : 'one_menu_content'"
                                                @click="onMenuItem(item_2, item_1)">
                                                <div class="title">
                                                    <span>{{ item_2.meta.title }}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </div>
                        <div class="menu_list_row one_menu_item"
                            v-if="item_1.children.length <= 0 && !noMenuPath.includes(item_1.path)">
                            <div :class="selectedKey.includes(item_1.path) ? 'one_menu_content one_menu_content_sel' : 'one_menu_content'"
                                @click="onMenuItem(item_1)">
                                <div class="title" style="font-weight: 500;">
                                    <span :class="`iconfont ${menuIcon[item_1.path]}`"
                                        v-if="menuIcon[item_1.path]"></span>
                                    <span>{{ item_1.meta.title }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </div>
        <div class="menu_box" style="width: 56px;" v-else>
            <template v-if="externalOrderPaths.includes(selectedKey)">
                <div class="menu_list_row one_sub_menu">
                    <a-popover placement="rightTop" overlayClassName="menu_popover">
                        <template #content>
                            <div class="two_menu_list_off_box">
                                <div v-for="item_1 in externalOrderRouters" :key="item_1.path">
                                    <div class="menu_list_row two_menu_item"
                                        v-if="item_1?.children?.length <= 0 && !noMenuPath.includes(item_1.path)">
                                        <div :class="selectedKey.includes(item_1.path) ? 'one_menu_content one_menu_content_sel' : 'one_menu_content'"
                                            @click="onMenuItem(item_1, item_1)">
                                            <div class="title">
                                                <span>{{ item_1.meta.title }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                        <div class="one_menu_content one_menu_content_sel">
                            <div class="title" style="font-weight: 500;">
                                <span :class="`iconfont icon-toufangluru`" style="margin: 0;"></span>
                            </div>
                        </div>
                    </a-popover>
                </div>
            </template>
            <template v-else>
                <div v-for="item_1 in menuDataList" :key="item_1.path">
                    <template
                        v-if="item_1.path != '/develop' && !item_1.hiddenMenu || item_1.path == '/develop' && developIds.includes(store.getters.userInfoData.id)">
                        <div class="menu_list_row one_sub_menu"
                            v-if="item_1.children.length > 0 && !noMenuPath.includes(item_1.path)">
                            <a-popover placement="rightTop" overlayClassName="menu_popover">
                                <template #content>
                                    <div
                                        :class="openKeys.includes(item_1.path) ? 'two_menu_list_open_box' : 'two_menu_list_off_box'">
                                        <div v-for="item_2 in item_1.children" :key="item_2.path">
                                            <template v-if="!item_2.hiddenMenu">
                                                <div class="menu_list_row two_sub_menu"
                                                    v-if="item_2?.children?.length > 0 && !noMenuPath.includes(item_2.path)">
                                                    <a-popover placement="rightTop" overlayClassName="menu_popover">
                                                        <template #content>
                                                            <div
                                                                :class="openKeys.includes(item_2.path) ? 'three_menu_list_open_box' : 'three_menu_list_off_box'">
                                                                <div v-for="item_3 in item_2.children"
                                                                    :key="item_3.path">
                                                                    <template v-if="!item_3.hiddenMenu">
                                                                        <div class="menu_list_row three_menu_item">
                                                                            <div :class="selectedKey.includes(item_3.path) ? 'one_menu_content one_menu_content_sel' : 'one_menu_content'"
                                                                                @click="onMenuItem(item_3, item_2, item_1)">
                                                                                <div class="title">
                                                                                    <span>{{ item_3.meta.title }}</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </template>
                                                                </div>
                                                            </div>
                                                        </template>
                                                        <div :class="selectedKey.includes(item_2.path) ? 'one_menu_content one_menu_content_sel' : 'one_menu_content'"
                                                            @click="onSubMenu(item_2, item_1)">
                                                            <div class="title">
                                                                <span>{{ item_2.meta.title }}</span>
                                                            </div>
                                                            <div class="icon">
                                                                <RightOutlined />
                                                            </div>
                                                        </div>
                                                    </a-popover>
                                                </div>
                                                <div class="menu_list_row two_menu_item"
                                                    v-if="item_2?.children?.length <= 0 && !noMenuPath.includes(item_2.path)">
                                                    <div :class="selectedKey.includes(item_2.path) ? 'one_menu_content one_menu_content_sel' : 'one_menu_content'"
                                                        @click="onMenuItem(item_2, item_1)">
                                                        <div class="title">
                                                            <span>{{ item_2.meta.title }}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </template>
                                        </div>
                                    </div>
                                </template>
                                <div :class="selectedKey.includes(item_1.path) ? 'one_menu_content one_menu_content_sel' : 'one_menu_content'"
                                    @click="onSubMenu(item_1)">
                                    <div class="title" style="font-weight: 500;">
                                        <span :class="`iconfont ${menuIcon[item_1.path]}`" style="margin: 0;"
                                            v-if="menuIcon[item_1.path]"></span>
                                    </div>
                                </div>
                            </a-popover>
                        </div>
                        <div class="menu_list_row one_menu_item"
                            v-if="item_1.children.length <= 0 && !noMenuPath.includes(item_1.path)">
                            <div :class="selectedKey.includes(item_1.path) ? 'one_menu_content one_menu_content_sel' : 'one_menu_content'"
                                @click="onMenuItem(item_1)">
                                <div class="title" style="font-weight: 500;">
                                    <span :class="`iconfont ${menuIcon[item_1.path]}`" style="margin: 0;"
                                        v-if="menuIcon[item_1.path]"></span>
                                </div>
                            </div>
                        </div>
                    </template>
                </div>
            </template>
        </div>
        <div class="unfold_box">
            <div class="unfold" @click="onSetUnfold">
                <template v-if="isUnfold">
                    <MenuFoldOutlined />
                    <span style="font-size: 14px; margin-left: 12px;">收起侧边栏</span>
                </template>
                <MenuUnfoldOutlined v-else />
            </div>
        </div>
    </div>
</template>

<script setup>
import { useStore } from "vuex";
import { onMounted, ref, watch, defineEmits } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { noMenuPath } from '@/defaultData/route';
import { menuIcon } from '@/defaultData/icon';
import { externalOrderPaths, externalOrderRouters } from './constance';
import { DownOutlined, UpOutlined, MenuFoldOutlined, MenuUnfoldOutlined, RightOutlined } from '@ant-design/icons-vue';

const emit = defineEmits(['onSetUnfold']);
const store = useStore();
const route = useRoute();
const router = useRouter();
const openKeys = ref([]);
const menuDataList = ref([]);
const isUnfold = ref(true);
const developIds = ref([1, 2, 3, 4]);
const selectedKey = ref(location.pathname);

/**
 * @function 点击菜单
 * @param item_3 
 */
const onMenuItem = (item_3) => {
    router.push(item_3.path);
    selectedKey.value = item_3.path;
};

/**
 * @function 打开子菜单
 * @param item_2 
 */
const onSubMenu = (item_2) => {
    if (openKeys.value.includes(item_2.path)) openKeys.value = openKeys.value.filter(it => {
        if (it != item_2.path) return it;
    })
    else openKeys.value.push(item_2.path)
};

/**
 * @function 菜单收起展开
 */
const onSetUnfold = () => {
    isUnfold.value = !isUnfold.value;
    emit('onSetUnfold', isUnfold.value);
};

/**
 * @function 设置菜单列表
 * @param data 
 */
const setMenuDataList = async () => {
    const userJsonStr = localStorage.getItem('user_info');
    const jsonStr = localStorage.getItem('router_data_list');
    if (jsonStr) menuDataList.value = await JSON.parse(jsonStr).filter((item_1) => {
        if (location.pathname.includes(item_1.path) && item_1.children.length > 0) openKeys.value.push(item_1.path);
        if (item_1.children.length > 0) item_1.children = item_1.children.filter((item_2) => {
            if (location.pathname.includes(item_2.path) && item_2.children.length > 0) openKeys.value.push(item_2.path);
            return item_2;
        });
        return item_1;
    });
    if (userJsonStr) store.dispatch("getUserInfoData", JSON.parse(userJsonStr));
};

/**
 * @function 监听路由对象整体变化
 */
watch(route, () => {
    setMenuDataList();
}, { immediate: true });

onMounted(() => {
    setMenuDataList();
});
</script>

<style lang="scss">
@use '@/_variables';

.layouts_menu {
    width: 100%;
    height: calc(100vh - 56px);
    background-color: #fff;
    position: relative;
    z-index: 100;

    @keyframes openMenu {
        from {
            display: none;
        }

        to {
            display: block;
        }
    }

    @keyframes offMenu {
        from {
            display: block;
        }

        to {
            display: none;
        }
    }

    .menu_box {
        height: calc(100% - 41px);
        padding-bottom: 16px;
        overflow: auto;

        .menu_list_row {
            .one_menu_content {
                height: 40px;
                margin: 4px;
                padding: 0 16px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                font-size: 14px;
                cursor: pointer;
                border-radius: 8px;

                .iconfont {
                    margin-right: 8px;
                }

                .icon {
                    font-size: 10px;
                    font-weight: 500;
                }
            }

            .one_menu_content:hover {
                background-color: rgba(0, 0, 0, 0.06);
            }

            .one_menu_content_sel {
                color: variables.$primary-color;
            }
        }

        .two_sub_menu,
        .two_menu_item {
            .one_menu_content {
                padding-left: 40px;
            }
        }

        .three_menu_item {
            .one_menu_content {
                // padding-left: 64px;
                padding-left: 58px;
            }
        }

        .two_menu_item,
        .three_menu_item {
            .one_menu_content_sel {
                background-color: variables.$bg-color-1;
            }
        }
    }

    .two_menu_list_open_box,
    .three_menu_list_open_box {
        display: block;
        animation-name: openMenu;
        animation-duration: 0.2s;
        animation-fill-mode: forwards;
    }

    .two_menu_list_off_box,
    .three_menu_list_off_box {
        display: none;
        animation-name: offMenu;
        animation-duration: 0.2s;
        animation-fill-mode: forwards;
    }


    .unfold_box {
        width: 100%;
        cursor: pointer;
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px 0;
        background-color: #fff;

        .unfold {
            width: 80%;
            padding: 6px 0;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            color: #999;
        }

        .unfold:hover {
            background-color: rgba(0, 0, 0, 0.06);
        }
    }
}

.layouts_menu::-webkit-scrollbar {
    display: none;
}

.menu_popover {

    .ant-popover-inner {
        padding: 4px 0;
    }

    .one_menu_content {
        padding: 0;
    }

    .menu_list_row {
        .one_menu_content {
            height: 40px;
            margin: 4px;
            padding: 0 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            font-size: 14px;
            cursor: pointer;
            border-radius: 8px;

            .icon {
                font-size: 10px;
                font-weight: 500;
                margin-left: 8px;
            }
        }

        .one_menu_content:hover {
            background-color: rgba(0, 0, 0, 0.06);
        }

        .one_menu_content_sel {
            color: variables.$primary-color;
        }
    }
}
</style>